export const isPrintMode = () => {
  return !!new URLSearchParams(window.location.search).get('print');
};
